module.exports = __webpack_public_path__ + "img/horizontal_4_3_5010.af1a43b6.png";